import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";
import { apiCallWrapper } from "../api/api.util";
import { ConfigGeneral, ConfigGeneralApi } from "../api/config-general.api";
import { ToastService } from "./toast.service";

@Injectable({
  providedIn: "root",
})
export class ConfigGeneralService {
  constructor(
    private configGeneralApi: ConfigGeneralApi,
    private toastService: ToastService,
  ) {}

  /**
   * Get all config-general values
   */
  public getAll = (): Observable<ConfigGeneral[]> => {
    return apiCallWrapper(this.configGeneralApi.getAll(), {
      toastService: this.toastService,
      action: "Fetching configuration",
    }).pipe(
      map((result) => {
        // Extract rows from QueryResult
        return result && result.rows ? result.rows : [];
      }),
    );
  };

  /**
   * Get a config value by name
   * @param name The config name to search for
   * @returns Observable of the config value as a string
   */
  public getConfigValueByName = (name: string): Observable<string | null> => {
    return this.getAll().pipe(
      map((configs) => {
        const config = configs.find((c) => c.name === name);
        return config ? config.value : null;
      }),
    );
  };

  /**
   * Get a config value by name and parse it as a number
   * @param name The config name to search for
   * @returns Observable of the config value as a number
   */
  public getConfigNumberByName = (name: string): Observable<number | null> => {
    return this.getConfigValueByName(name).pipe(
      map((value) => {
        if (value === null) return null;
        const parsed = parseInt(value, 10);
        return isNaN(parsed) ? null : parsed;
      }),
    );
  };
}
